import { storage } from '@/utils';

const CACHE_KEY = 'consumer_rights_form';

export function getFormCache() {
  try {
    const raw = storage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveFormCache(data) {
  storage.setItem(CACHE_KEY, JSON.stringify(data));
}

export function clearFormCache() {
  storage.removeItem(CACHE_KEY);
}

export const NOTICE_CONTENT = `消费者权益服务站职责
为保障消费者（下称"您"）的合法权益、落实企业自律管理，基于《消费者权益保护法》《电子商务法》等相关法律法规的规定，在【深圳市市场监督管理局南山监管局、深圳市南山区消费者委员会】指导下建立【消费者权益服务站】，为了创造更好的消费环境，提升您的消费体验。履行如下职责：
1、接待、受理和处理您的投诉。您在使用产品和接受服务过程中出现的任何不满和意见，均可反馈至本站。本站将积极对接到的投诉和纠纷进行核实调查，在5个工作日内联系您协商争议处理。
2、监督商品和服务质量。您可以通过本站，对您所享受的橡树黑卡旗下商品和服务的满意度进行评价。本站重视您提出的所有申（投）诉，认真地对相关事件和人员展开调查，并在7个工作日内通知您处理结果。
3、督促监管要求落地。本站按照法规政策，督促橡树黑卡旗下商品和服务规范经营，落实规则透明、明码标价、收费公示等互联网平台消费标准，接受市场监管部门的指导和监督。
4、宣传消费权益保障。本站提供有关消费者权益保护方面的法律法规和政策咨询，解读消费者基本权利。在收悉相关政府部门认定的具有典型性、普遍性的侵害互联网消费者合法权益的行为后，本站也将及时向您做出提示。
5、信息收集和反馈。您的意见和诉求，将提高互联网线上消费商品和服务的质量。本站将适时汇总收集到的意见和诉求，分析其中的热点、难点问题，为橡树黑卡旗下商品和服务提升质量提供依据；并将其中共性问题和突出问题及时向有关部门反映，为行业的进步和政策的制定提供参考。在反馈您的意见和诉求的过程中，本站将严格遵守国家有关个人信息保护的法律、法规和政策规定，保护您的个人信息安全。`;

export function validatePhone(phone) {
  if (!phone) {
    return '请填写常用联系手机号';
  }
  if (!/^1[3-9]\d{9}$/.test(phone)) {
    return '请填写11位正确的手机号';
  }
  return '';
}
